<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <div class="cdc-form-field actif">
    <div class="cdc-label">{{ data.subtitle }}</div>
    <input matInput type="text" [(ngModel)]="text">
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()" [disabled]="!text">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
